import useIsMobile from 'hooks/use-is-mobile';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import SearchTracking from 'utils/search-tracking';
export const useRefreshMap = ({ mapWidgetRef, // Used across alot of this - not in redux
centerLatLng, // in a few places
spots, // Is transformed in spotMap -  not in redux
zoom, // This is state on SpotMap - not in redux
 }) => {
    const { filterId } = useSelector((state) => state.filters);
    const destinationTitle = useSelector((state) => state.destination.data.title // Need to type
    );
    const isSpotDetailOpen = useSelector((state) => Boolean(state.spots.selectedSpotId));
    const highlightedSpotId = useSelector((state) => state.spots.highlightedSpotId);
    const previewedSpotId = useSelector((state) => state.spots.previewedSpotId);
    const activeRatingTypes = useSelector((state) => state.filters.activeRatingTypes);
    const kmlMapLayerEnabled = useSelector(
    // @ts-expect-error - to be reviewed MR 9/25/25
    (state) => state.search.data.kmlMapLayerEnabled // Maybe deprecated
    );
    const kmlMapLayerURL = useSelector(
    // @ts-expect-error - to be reviewed MR 9/25/25
    (state) => state.search.data.kmlMapLayerURL // Maybe deprecated
    );
    const isMobile = useIsMobile();
    const { searchUUID } = SearchTracking.getValues();
    const [prevFilterId, setPrevFilterId] = useState(filterId);
    return useCallback(() => {
        const mapWidget = mapWidgetRef.current;
        const hasSearchRequestIdChanged = mapWidget.setSearchRequestId(searchUUID);
        const hasFilterIdChanged = prevFilterId !== filterId;
        if (hasFilterIdChanged) {
            setPrevFilterId(filterId);
        }
        mapWidget.setCenterLatLngAndTitle(centerLatLng.lat, centerLatLng.lng, destinationTitle);
        mapWidget.setIsMobile(isMobile);
        mapWidget.setHighlightedSpotId(highlightedSpotId);
        mapWidget.setPreviewedSpotId(previewedSpotId);
        mapWidget.refreshSpots(spots);
        mapWidget.setZoom(zoom);
        mapWidget.setRatingFilters(activeRatingTypes);
        // If Spot Details is open then close info window as the user can view details of any spot from the spot list
        // and the info window would not be in sync with the selected spot.
        // Also close info window if the search request ID has changed.
        if (isSpotDetailOpen ||
            hasSearchRequestIdChanged ||
            hasFilterIdChanged) {
            mapWidget.closePopup();
        }
        // KML layer feature is likely obsolete.
        // Migrated code from the SHGoogleMap.jsx Class component.
        if (kmlMapLayerEnabled) {
            mapWidget.addKMLLayer(kmlMapLayerURL);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchUUID,
        prevFilterId,
        filterId,
        centerLatLng.lat,
        centerLatLng.lng,
        destinationTitle,
        isMobile,
        highlightedSpotId,
        previewedSpotId,
        spots,
        zoom,
        activeRatingTypes,
        isSpotDetailOpen,
        kmlMapLayerEnabled,
        kmlMapLayerURL,
    ]);
};
